<template>
  <v-container class="v-container">
    <v-layout justify-center align-center>
      <v-flex xs12 sm6 md4>
        <div class="page-title">Login</div>
        <div class="login-form">
        <v-form @submit.prevent="submit">
          <v-layout column class="login-layout">
            <v-flex xs12 sm10 md8 lg4>
              <input
                v-model="email"
                id="email"
                type="text"
                placeholder="Email"
                class="custom-input"
              />
            </v-flex>
            <v-flex xs12 sm10 md8 lg4>
              <input
                v-model="password"
                id="password"
                type="password"
                placeholder="Password"
                class="custom-input"
              />
            </v-flex>
            <p v-if="errorMessage" class="error-message">
              {{ errorMessage }}
            </p>
            <v-dialog v-model="forgotPassword" width="500">
              <template #activator="{ on }">
                <div v-on="on" class="forgot-block">
                  <span>Forgot password?</span>
                </div>
              </template>
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Forgot password
                </v-card-title>
                <v-card-text>
                  <p style="text-align: left" class="mt-4">Please enter your Email</p>
                  <input
                    v-model="forgotEmail"
                    :class="{
                      'wrong-input': $v.forgotEmail.$invalid && showErrors,
                    }"
                    type="email"
                    placeholder="Email"
                    id="email-to-forgot"
                    class="custom-input"
                  />
                  <p v-if="showErrors" style="text-align: left" class="error-message">
                    <span v-if="!$v.forgotEmail.required">Email field is required.</span>
                    <span v-if="!$v.forgotEmail.email">The input must be a proper email!</span>
                  </p>
                  <p v-if="errorReset" style="color: crimson">
                    User with this email does not exist.
                  </p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    id="cancel-change-pass"
                    color="blue-grey lighten-4"
                    @click="forgotPassword = false"
                  >
                    Cancel and close
                  </v-btn>
                  <v-btn id="change-pass" color="green lighten-3" @click="resetPassword">
                    Send
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-flex xs12 sm12 md12 class="submit-button-container">
              <button class="submit-button" type="submit" id="submit-login">Login</button>
            </v-flex>
            <router-link :to="{ name: 'registration' }"
              ><div class="registration">
                <span>Registration</span>
              </div></router-link
            >
          </v-layout>
        </v-form>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import AuthorizService from '@/services/AuthorizService';
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
  data() {
    return {
      errorReset: false,
      showErrors: false,
      forgotPassword: false,
      forgotEmail: '',
      email: '',
      password: '',
      errorMessage: false,
    };
  },
  computed: {
    ...mapState(['loginInfo']),
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar', 'getUserInfo', 'getUserProfileInfo']),
    ...mapMutations(['login', 'setProfileUsername']),
    getJSONtoSend() {
      return {
        email: this.email,
        password: this.password,
      };
    },
    resetPassword() {
      this.showErrors = false;
      this.errorReset = false;
      if (!this.$v.$invalid) {
        const jsonToSend = {
          email: this.forgotEmail,
        };
        this.setLoading({ show: true, text: 'Reseting...' });
        AuthorizService.resetPassword(jsonToSend)
          .then((response) => {
            this.setLoading({ show: false, text: '' });
            this.forgotPassword = false;
            this.showSnackbar('Check your email with next instruction!');
            console.log(response);
          })
          .catch((err) => {
            this.setLoading({ show: false, text: '' });
            if (err.response.status === 500) {
              this.errorReset = true;
            }
          });
      } else {
        this.showErrors = true;
      }
    },
    submit() {
      this.setLoading({ show: true, text: 'Saving...' });
      this.errorMessage = '';
      let jsonToSend = this.getJSONtoSend();
      AuthorizService.postApiToken(jsonToSend)
        .then((response) => {
          this.setProfileUsername(this.email.split('@')[0]);
          this.setLoading({ show: false, text: '' });
          this.login(response.data);
          this.getUserInfo();
          this.getUserProfileInfo();
          this.$router.push({ name: 'auctionList' });
        })
        .catch(() => {
          this.setLoading({ show: false, text: '' });
          this.errorMessage = 'Incorrect Login or Password';
        });
    },
  },
  created() {
    if (this.loginInfo.isLogged) {
      this.$router.push({ name: 'auctionList' });
    } else {
      this.$router.push({ name: 'login' });
    }
  },
  validations: {
    forgotEmail: {
      required,
      email,
    },
  },
};
</script>

<style scoped lang="scss">
.login-form {
  max-width: 450px;
  position: relative;
}
.custom-input {
  background-position-y: center;
  background-position-x: 10px;
  padding-left: 50px;
  width: 100%;
  height: 46px;
  color: #216169;
  background-color: #c4c4c44d;
  font-size: 12px;
  
  margin-bottom: 17px;

  &[type='text'] {
    background-image: url('../assets/user.png');
  }
  &[type='password'] {
    background-image: url('../assets/password.png');
    font-size: 18px;
    font-weight: 600;
  }
  &::placeholder {
    color: #216169;
    font-size: 12px;
    font-weight: normal;
  }
  &:focus {
    outline: 2px solid #216169;
  }
}
.submit-button-container {
  margin-top: 8px;
}
.forgot-block {
  
  color: #216169;
  display: flex;
  font-size: 12px;
  cursor: pointer;
  font-weight: 400;
  flex-direction: row;
  justify-content: flex-end;
  text-decoration: underline;
}
.registration {
  
  margin-top: 14px;
  color: #216169;
  display: flex;
  font-size: 12px;
  cursor: pointer;
  font-weight: 400;
  flex-direction: row;
  justify-content: center;
  text-decoration: underline;
}
.submit-button-container {
  
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.login-layout {
  .submit-button {
    padding: 9px 38px;
    color: #ffffff;
    background-color: #536f51c4;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
}
.custom-input[type='email'] {
  background-repeat: no-repeat;
  background-image: url('../assets/Vector_Smart_Object(1).png');
}
.v-container .input-group__input {
  background: #cce9ee;
  padding: 12px 10px;
}
.error-message {
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #fd6262;
}
.v-container /deep/ .input-group__details:before,
.v-container /deep/ .input-group__details:after {
  display: none;
}
.v-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  margin: 0;
  justify-content: center;
  align-items: center;
}

.login-form {
  box-shadow: 0 3px 10px 1px rgba(18, 13, 10, 0.13);
  background-color: #ffffff;
  margin-right: auto;
  margin-left: auto;
  padding: 46px 35px;
}

.register-link {
  text-decoration: none;
  color: gray;
  text-align: left;
}
</style>
